import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  ALL_MODULES,
  getDownloadURL,
  useActivityTracker
} from '@nile/components';
import { StripCell } from '../../TimesheetComponents';

const CellWrapper = styled.div`
  width: 100%;
  max-width: calc(100% - 200px);
  .Polaris-Link {
    width: 100%;
  }
  .name {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 16px;
  }
  .tag {
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
    line-height: 12px;
  }
`;

const LogoImage = styled.img`
  max-height: 40px;
  max-width: 100%;
`;

function Logo(props) {
  const { client } = props;
  const { logoFileName, accountId, downloadURL } = client;
  const module = ALL_MODULES.clientAvatar;
  const details = {
    fileName: logoFileName,
    clientId: accountId
  };
  const fallbackUrl = getDownloadURL({ module, details });
  const downloadUrl = downloadURL || fallbackUrl;
  return (
    <div className="flex center jcenter full-width">
      <LogoImage src={downloadUrl} url={downloadUrl} />
    </div>
  );
}

const ClientCell = (props) => {
  const { cell } = props;
  const cellData = cell.row?.original;
  const { client } = cell.row?.original;

  function handleTechnicianClick() {
    useActivityTracker({
      event: 'Clicked to drill down on clients (All timesheets)'
    });
    cell.column?.actions?.viewClientTechnician(client);
  }

  const stripCellData = {
    displayValue: cellData?.totalTimespent,
    hoursData: {
      afterHoursData: {
        timespent: cellData?.afterHours
      },
      billableHours: {
        timespent: cellData?.billable
      },
      nonBillableHours: {
        timespent: cellData?.nonBillable
      }
    }
  };

  return client ? (
    <div className="fx actr">
      <CellWrapper onClick={handleTechnicianClick} className="fx g5 ptr">
        <span className="fx actr jctr">
          <Logo className="logo" client={client} />
        </span>
        <div
          className="fx actr ellipsis"
          title={client?.name || `${client?.firstName} ${client?.lastName}`}
        >
          <TextStyle weight="Bold">
            {client?.name || `${client?.firstName} ${client?.lastName}`}
          </TextStyle>
        </div>
      </CellWrapper>
      <div className="fg1">
        <StripCell cell={{ ...cell, value: stripCellData }} />
      </div>
    </div>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
};

export default ClientCell;
